import React from 'react';
import { useMutation } from '@apollo/client';
import UpdateScenePlaybackMetadataMutation from './UpdateScenePlaybackMetadataMutation';

interface IUpdateScenePlaybackMetadataConnectorApolloProps {
  children: ({
    updateScene,
  }: {
    updateScene: (
      sceneId: number,
      lastPlaybackPosition: number,
      isPlaybackCompleted: boolean,
      __typename: string
    ) => any;
  }) => React.ReactElement;
}

const UpdateScenePlaybackMetadataConnectorApollo: React.FC<
  IUpdateScenePlaybackMetadataConnectorApolloProps
> = ({ children }) => {
  const [update] = useMutation(UpdateScenePlaybackMetadataMutation);

  const optimisticResponse = {
    mindfulnessBalance: {
      scene: {
        updateScenePlaybackMetadata: {
          code: 200,
          __typename: 'BasicMutationSuccess',
        },
        __typename: 'BalanceSceneMutation',
      },
      __typename: 'MindfulnessBalanceMutation',
    },
  };

  const updateScene = async (
    sceneId: number,
    lastPlaybackPosition: number,
    isPlaybackCompleted: boolean,
    __typename: string
  ) => {
    const response = await update({
      variables: { sceneId, lastPlaybackPosition, isPlaybackCompleted },
      optimisticResponse: optimisticResponse,
      update: (cache, { data }) => {
        cache.modify({
          id: cache.identify({
            __typename: __typename,
            id: sceneId,
          }),
          fields: {
            playbackMetadata() {
              return {
                __typename: __typename,
                lastPlaybackPosition: lastPlaybackPosition,
                isPlaybackCompleted: isPlaybackCompleted,
              };
            },
          },
        });
      },
    });

    return response.data.mindfulnessBalance;
  };

  return children({ updateScene });
};

export default UpdateScenePlaybackMetadataConnectorApollo;
